
$(document).ready(function() {

  /* Homepage hero slider ----------------*/
 
  $("#homepage-slider").owlCarousel({
      navigation : false, // Show next and prev buttons
      slideSpeed : 4000,
      paginationSpeed : 4000,
      singleItem:true,
      lazyLoad: true,
      
      autoPlay: 8000,
      
      pagination: true,
      transitionStyle : "fade",
      afterInit: function(){
        $('#homepage-slider').css({ 'opacity': '1' });
            }
  });


}); // end document ready
